import { CardContent, CardContentProps } from "@mui/material";

export default (props: CardContentProps) => {
  const { sx: sxContent } = props;

  const sx = [
    {
      backgroundColor: "background.paper",
      color: "text.primary",
      mt: "0.1rem",
      mb: "0.1rem",
    },
    // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
    ...(Array.isArray(sxContent) ? sxContent : [sxContent]),
  ];
  return (
    <CardContent {...props} sx={sx}>
      {props.children}
    </CardContent>
  );
};
